<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 250px;" class="ml-1">
								<v-text-field clearable dense label="资源名称" outlined v-model="query.resourceName">
								</v-text-field>
							</div>
							<div style="width: 250px;" class="ml-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 250px;" class="ml-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<v-btn @click="getResourceList" color="info" class="ml-1">查询</v-btn>
						</v-col>
						
					
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-3">
							<v-btn small @click="add.dialog = true" color="info">上传资源</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.resourceView="{item}">
					<v-img :src="item.resourcePath+'?imageView2/1/w/200/h/200'" width="50px" height="50px" @click="viewResource(item)"></v-img>
					
				</template>
				<template v-slot:item.resourceType="{ item }">
					<v-chip :color="getTypeColor(item.resourceType)" dark>
						{{ getTypeName(item.resourceType) }}
					</v-chip>
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense>
					<v-col cols="2">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="8" offset="1" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 上传多媒体资源 dialog -->
		<v-dialog title="上传多媒体资源" v-model="add.dialog" max-width="650" persistent>
			<v-card>
				<v-card-title>上传多媒体资源</v-card-title>
				<v-card-text>
					<v-row dense>
						
						<v-col cols="6">
							<v-file-input @change="fileSelected" label="选择文件" v-model="upload.picture.content.files" dense outlined show-size small-chips />
						</v-col>
						<v-col cols="6">
							<v-progress-circular v-if="upload.picture.content.percent > 0 " color="primary" size="40" width="2" v-model="upload.picture.content.percent">
							  {{ upload.picture.content.percent }}%
							</v-progress-circular>
						</v-col>
						
						<v-col cols="6">
							<v-text-field label="资源名称" v-model="add.model.resourceName" dense outlined clearable></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-avatar rounded>
								<v-img v-if="upload.picture.content.key" :src="upload.picture.content.key" width="50"
									height="50" />
							</v-avatar>
							
						</v-col>
						<v-col cols="12">
							<v-text-field label="资源路径" v-model="add.model.resourceKey" dense outlined disabled>
							</v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddResource" color="success">提交</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 预览多媒体资源 dialog -->
		<v-dialog title="预览多媒体资源" v-model="preview.dialog" width="800">
			<v-card>
				<v-card-title>预览多媒体资源</v-card-title>
				<v-card-text>
					<v-img :src="preview.resourcePath+'?imageView2/2/w/750'"></v-img>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="preview.dialog=false">关闭</v-btn>
					
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		
	</v-card>
</template>

<script>
	import * as qiniu from 'qiniu-js'
	import moment from 'moment'
	import global from '../../../config/global'
	import storage from "../../../config/storage"
	export default {
		name: "resource-list",
		data() {
			return {
				imgPrev : global.config.imgPre,
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '内容管理',
						disabled: true
					},
					{
						text: '资源列表',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '上传者姓名',
							align: 'start',
							value: 'staffName',
							sortable: false
						},
						{
							text: '资源名称',
							value: 'resourceName',
							sortable: false
						},
						{
							text: '多媒体类型',
							value: 'resourceType',
							sortable: false
						},
						{
							text: '缩略图',
							value: 'resourceView',
							sortable: false
						},
						{
							text: '资源路径',
							value: 'resourcePath',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
					],
					list: [],
				},
				search: "",
				query: {
					loading: false,
					page: 1,
					size: 20,
					//start: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
					start: "",
					end: "",
					resourceName: "",
				},
				upload: {
					picture: {
						
						content: {
							files:null, // 多选文件用[]
							pre: "assets/img/",
							mid: "",
							url: "",
							percent: 0,
							key: "" // 全路径
						}
					}
				},
				// 上传的监视事件
				observe: {
					next: this.onNext,
					error: this.onError,
					complete: this.onComplete
				},
				add: {
					dialog: false,
					model: {
						resourceName: "",
						resourceKey: "",
					}
				},
				preview:{
					dialog:false,
					resourceType:"",
					resourcePath:""
				}

			}
		},
		created() {
			this.getResourceList();

		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getResourceList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getResourceList();
			},
			getTypeColor(resourceType){
				return "success";
			},
			getTypeName(resourceType){
				let typeName = "";
				if (resourceType == "1"){
					typeName = "图片";
				}else if (resourceType == "2"){
					typeName = "音频";
				}else if (resourceType == "3"){
					typeName = "视频";
				}else if (resourceType == "4"){
					typeName = "文件";
				}
				return typeName;
			},
			fileSelected(file) {
				
				this.uploadFile(file);
			},
			onNext(res) {
				this.upload.picture.content.percent = res.total.percent.toFixed();
			},
			onComplete(res) {
				console.log(res);
				// 上传完成 显示缩略图
				this.upload.picture.content.key = this.imgPrev + res.key;
				

			},
			onError(err) {
				this.$noty.error("上传失败：" + err.message);
			},
			uploadFile(file) {
				const that = this;

				if (file) {
					const indexOfSuffix = file.name.lastIndexOf(".");
					//文件后缀
					const suffix = indexOfSuffix >= 0 ? file.name.substr(indexOfSuffix) : "";
					// 上传的文件名
					const filename = "op_" + moment().unix() + suffix;
					// 上传的key
					const key = this.upload.picture.content.pre + this.upload.picture.content.mid + filename;
					//const url = this.upload.picture.defaultPre + key;
					
					let uploadToken = storage.getUploadImgToken();
					if (!uploadToken) {
						this.$noty.error("上传失败,上传凭证已失效，请联系管理员");
						return;
					}

					// 请求上传的token 然后上传到七牛
					const putExtra = {
						fname: "",
						params: {},
						mimeType: null
					};
					const config = {
						useCdnDomain: true,
						region: qiniu["region"].z2
					};
					let observable = qiniu["upload"](file, key, uploadToken, putExtra, config);
					observable.subscribe(this.observe);
					
					//设置资源路径 名称
					this.add.model.resourceName = file.name;
					this.add.model.resourceKey = key;
					
				}
			},
			getResourceList() {
				const that = this;
				this.query.loading = true;


				let url = `/content/resource/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.resourceName) {
					url += "&resourceName=" + this.query.resourceName;
				}
				if (this.query.staffNo) {
					url += "&staffNo=" + this.query.staffNo;
				}


				this.axios.get(url).then(response => {
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.$noty.error("获取失败：" + response.data["message"]);
					that.query.loading = false;
				})
			},
			submitAddResource() {

				if (!this.upload.picture.content.key){
					this.$noty.error('请先上传资源');
					return
				}
				
			
				if (!this.add.model.resourceName) {
					this.$noty.error('资源名称不能为空');
					return
				}
				if (!this.add.model.resourceKey) {
					this.$noty.error('请先上传资源');
					return
				}

				// api
				const that = this;
				let url = `/content/resource/create`;
				let postData = this.add.model;

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getResourceList();
							that.add.dialog = false;

							// 清除本次的数据
							that.upload.picture.content.percent = 0;
							that.add.model.resourceName = "";
							that.add.model.resourceKey = "";
							that.upload.picture.content.key = "";
							that.upload.picture.content.files = null;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
			viewResource(item){
				console.log(item);
				this.preview.dialog = true;
				this.preview.resourceType = item.resourceType;
				this.preview.resourcePath = item.resourcePath;
			}

		}
	}
</script>

<style>
</style>
